import { getErrorMessage, rootDomainCookie, TRADEIN_ESTIMATE_COOKIE_NAME } from '@beef/shop-common';
import { createAsyncThunk } from '@reduxjs/toolkit';

import pushEvent, { SELECT_TRADE_IN_TO_PURCHASE } from 'pushEvent/index';
import { getTradeInCalculatorButtonHref } from 'store/widgets/TradeInCalculator/selectors';
import { tradeInValidate } from 'store/widgets/TradeInNewCalculator/common/actions';
import { selectTradeInIsValid, selectTradeInSummary } from 'store/widgets/TradeInNewCalculator/selectors';

export const tradeInSubmit = createAsyncThunk(
  'tradeId/submit',
  async (_, { getState, dispatch }): Promise<void> => {
    const state = getState();
    const buttonHref = getTradeInCalculatorButtonHref(state);

    if (selectTradeInIsValid(state)) {
      try {
        rootDomainCookie.set(TRADEIN_ESTIMATE_COOKIE_NAME, JSON.stringify(selectTradeInSummary(state)));
      } catch (e) {
        throw Error(`TradeIn cookie error: ${getErrorMessage(e)}`);
      }

      pushEvent(SELECT_TRADE_IN_TO_PURCHASE);

      window?.open(buttonHref, '_self');
    } else {
      dispatch(tradeInValidate());
    }
  },
);
